import { render, staticRenderFns } from "./HGSGiseIgnored.vue?vue&type=template&id=bb5e356e&"
import script from "./HGSGiseIgnored.vue?vue&type=script&lang=js&"
export * from "./HGSGiseIgnored.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports